<script lang="ts">
    import TemplateIcon from './TemplateIcon.svelte';
    import { Tooltip, tooltip } from '@svelte-plugins/tooltips';
    import src from './svg/job_note.svg';
    import { _ } from 'svelte-i18n';
    import { app } from '../../../stores/app';

    export let note: string;
    export let tags: string[] = [];
    export let extra: Record<string, any> = {};
    export let jobType: string|null = null;
    export let scale: number = 0.7;

    let content: string = '';
    let showWithTooltip: boolean = true;

    let extraAttributesLabels = $app.account.getSettingsReadonly()?.mobile_app_options?.delivery_action_attributes?.[jobType || ''];

    $: {
        if (note || tags.length) {
            content = '<div style="font-style: italic; font-size: 80%;">'+$_('Jobs note')+':</div><div>'+note+'</div>';
        } else {
            content = '';
        }
        if (tags.length) {
            content += '<div style="padding-top: 5px">'
            for (let tag of tags) {
                content += '<span style="display: inline-block; border-radius: 5px; background-color: #ddd; padding: 0px 5px 2px;">'+tag+'</span>';
            }
            content += '</div>'
        }
        if (extra && Object.keys(extra).length) {
            for (let attr in extra) {
                if (['total_weight', 'parcels', 'non_normative_size'].indexOf(attr) == -1) {
                    let xlabel = extraAttributesLabels?.[attr]?.label || attr;
                    let xoption = extraAttributesLabels?.[attr]?.options?.filter((o: any) => typeof(o) == 'object' && Object.keys(o)[0] == extra[attr])[0];
                    content += '<div style="padding-top: 5px; font-style: italic; font-size: 80%; line-height: 100%">'+xlabel+':</div><div>'+(xoption ? Object.values(xoption)[0] : extra[attr])+'</div>';
                }
            }
        }
        showWithTooltip = false;
        setTimeout(() => showWithTooltip = true, 0);
    }
</script>

{#if showWithTooltip}
<div use:tooltip={{content: content, theme: 'lastmile-tooltip'}}>
    <TemplateIcon {src} alt="Note added" {scale}/>
</div>
{:else}
<div>
    <TemplateIcon {src} alt="Note added" {scale}/>
</div>
{/if}

<style>
    :global(.tooltip.lastmile-tooltip) {
        --tooltip-color: #000000;
        --tooltip-background-color: #f5f5f5;
    }
    :global(.tooltip.lastmile-tooltip-no-events) {
        --tooltip-color: #000000;
        --tooltip-background-color: #f5f5f5;
    }
</style>
